import { api } from '@services';

import {
  UpdateStatusPriority,
  UpdateStatusType,
} from '@models/UpdateStatus.model';
import { IUpdateRawQueryListApiModel } from '@models/Update.model';

interface IChangeUpdate {
  updateStatusId: string;
  subject?: string;
  description?: string;
  originalMessage?: string;
  productId?: string;
  type?: UpdateStatusType;
  priority?: UpdateStatusPriority;
  assigneeId?: string | null;
}

const changeUpdateStatus = async ({
  updateStatusId,
  ...rest
}: IChangeUpdate): Promise<IUpdateRawQueryListApiModel> => {
  const { data: update } = await api.patch<IUpdateRawQueryListApiModel>(
    `/updateStatuses/${updateStatusId}`,
    rest,
  );

  return update;
};

export { changeUpdateStatus };
